import { getLogger } from '@jitsi/logger';
import React from 'react';

import { MEDIA_TYPE } from '../../../react/features/base/media/constants';
import {
    getLocalJitsiAudioTrack,
    getLocalJitsiVideoTrack
} from '../../../react/features/base/tracks/functions';
import { muteLocal } from '../../../react/features/video-menu/actions.any';
import { showCustomNotification } from '../../components/notifications';
import { physicalKeyPressed } from '../../components/virtual-keyboard/actions';
import WildixUIEvents from '../../service/WildixUIEvents';
import CameraActions from '../CameraActions';
import CameraControll from '../CameraControll';
import { WizyconfNotification } from '../components/notifications';
import {
    CAMERA_OFF_CLASSNAME,
    NOTIFICATION_HIDE_TIMEOUT
} from '../constants';

import FocusControll from './focusControll';


const logger = getLogger(__filename);

const PREVENTED_KEYS = [ 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowDown', 'ArrowUp' ];

export default class KeyboardControl {
    cameraActions = new CameraActions();
    focusControll = new FocusControll();
    activeDomElm = null;
    _onkeyupInstance = null;
    _keydownInstance = null;
    _onmouseInstance = null;

    /**
     * Originaly it was for menu navigation: Do not allow repeat action to fast to see
     * how focused buttons changes. But next reason is due to chinese remote controll
     * can duplicate events even if hardware button presed once
     */
    skipKeyEventRepeatDuringMs = 0;

    // Map keyCode to action
    keyCodes = {
        13: {
            key: 'Enter',
            action: e => {
                this.focusControll.enter();
                logger.log('Name: Enter', 'KeyKod: 13');
            }
        },
        27: {
            key: 'Escape',
            action: e => {
                this.focusControll.closeAll();
                logger.log('Name: Escape', 'KeyKod: 27');
            }
        },
        36: {
            key: 'Home',
            action: e => {
                logger.log('Name: Home', 'KeyKod: 36');
            }
        },
        37: {
            key: 'ArrowLeft',
            action: e => {
                this.focusControll.prev();
                logger.log('Name: ArrowLeft', 'KeyKod: 37');
            }
        },
        38: {
            key: 'ArrowUp',
            action: e => {
                this.focusControll.up();
                logger.log('Name: ArrowUp', 'KeyKod: 38');
            }
        },
        39: {
            key: 'ArrowRight',
            action: e => {
                this.focusControll.next();
                logger.log('Name: ArrowRight', 'KeyKod: 39');
            }
        },
        40: {
            key: 'ArrowDown',
            action: e => {
                this.focusControll.down();
                logger.log('Name: ArrowDown', 'KeyKod: 40');
            }
        },

        // Not usual keyboard keys
        124: {
            key: 'Webcam',
            action: e => {
                const localVideo = getLocalJitsiVideoTrack(APP.store.getState());

                if (localVideo) {
                    APP.store.dispatch(muteLocal(!localVideo.isMuted(), MEDIA_TYPE.VIDEO));
                }
                APP.store.dispatch(showCustomNotification({
                    titleKey: 'keyboardShortcuts.videoMute'
                }, WizyconfNotification, 'wizyconf-notify', NOTIFICATION_HIDE_TIMEOUT));
                logger.log('Name: Webcam', 'KeyKod: 124');
            }
        },
        125: {
            key: 'SwitchWebcam',
            action: e => {
                APP.wildix.wizy.switchVideoInputDevice();
                logger.log('Name: SwitchWebcam', 'KeyKod: 125');
            }
        },
        128: {
            key: 'Mute',
            action: e => {
                APP.store.dispatch(showCustomNotification({
                    titleKey: 'notify.mutedTitle',
                    description: React.createElement('div', {
                        className: `${CAMERA_OFF_CLASSNAME} fa fa-microphone-slash`,
                        key: 0
                    }, null)
                }, WizyconfNotification, 'wizyconf-notify', NOTIFICATION_HIDE_TIMEOUT));
                const localAudio = getLocalJitsiAudioTrack(APP.store.getState());
                const isMuted = localAudio ? !localAudio.isMuted() : false;

                APP.store.dispatch(muteLocal(isMuted, MEDIA_TYPE.AUDIO));
                logger.log('Name: Mute', 'KeyKod: 128');
            }
        },
        129: {
            key: 'Settings',
            action: e => {
                logger.log('Name: Settings', 'KeyKod: 129');
            }
        },
        130: {
            key: 'Record',
            action: e => {
                // APP.UI.showToolbar({ timeout: 5600 });

                // $('#toolbar_button_switch_record').trigger('click');
                logger.log('Name: Record', 'KeyKod: 130');
            }
        },
        131: {
            key: 'CameraActions',
            action: e => {
                this.cameraActions.changeMode();
                logger.log('Name: CameraActions', 'KeyKod: 131');
            }
        }
    };

    // Escape key
    closeAllCode = 27;

    // Key codes which will processed on keydown event
    keyDownOnlyCodes = [
        37, 38, 39, 40, // Arrow keys
        124 // Webcam on/Off
    ];

    _onkeyupInstance = null;
    _keydownInstance = null;
    _onmouseInstance = null;

    constructor() {
        this._onkeyupInstance = this._onkeyup.bind(this);
        this._keydownInstance = this._onkeydown.bind(this);
        this._onmouseInstance = this._onmouseinteraction.bind(this);
        window.addEventListener('keyup', this._onkeyupInstance, true);
        window.addEventListener('keydown', this._keydownInstance, true);
        window.addEventListener('mousedown', this._onmouseInstance, true);
        window.addEventListener('mousemove', this._onmouseInstance, true);

        APP.wildix.eventEmitter.on(WildixUIEvents.VISITOR_MODE, this.destroy);

        this._lastKeyDownAt = 0;
    }

    reinitialize() {
        this.focusControll.reinitialize();
    }

    _checkPTZCameraControlEnabled(e) {
        return CameraControll.PTZ_CONTROL_ENABLED && PREVENTED_KEYS.includes(e.which);
    }

    _onkeyup(e) {
        APP.store.dispatch(physicalKeyPressed(e));


        if (this._checkPTZCameraControlEnabled(e)) {
            return;
        }

        if (this.keyDownOnlyCodes.indexOf(arguments[0].which) === -1) {

            if (Date.now() - this._lastKeyDownAt < this.skipKeyEventRepeatDuringMs) {
                console.log('[keyboardControll] keyup skipped (250ms since last event)', arguments[0].which);

                return false;
            }
            this._lastKeyDownAt = Date.now();


            this._processEvent(e);
        }
    }
    _onkeydown(e) {
        if (this.activeDomElm !== document.activeElement) {
            this.activeDomElm = document.activeElement;
            document.activeElement.blur();
        }
        if (this._checkPTZCameraControlEnabled(e)) {
            return;
        }

        if (this.keyDownOnlyCodes.indexOf(arguments[0].which) > -1) {
            // Do not allow repeat action to fast,
            // delay 250ms allow to see tendency of focus changing
            if (Date.now() - this._lastKeyDownAt < this.skipKeyEventRepeatDuringMs) {
                console.log('[keyboardControll] keydown skipped (250ms since last event)', arguments[0].which);

                return false;
            }
            this._lastKeyDownAt = Date.now();
            if (e.target.id !== 'usermsg') {
                e.preventDefault(); // Prevent native scrolling
            }
            this._processEvent(e);
        }
    }
    _onmouseinteraction(e) {
        if (this.focusControll.isMainWindowControllFocused()) {
            this.focusControll.unfocus();
        }
    }
    _processEvent(e) {
        const keycode = e.which;
        const action = this.keyCodes[keycode];

        if (typeof action !== 'object' || APP.store.getState()['features/base/conference'].passwordRequired) {
            return;
        }

        // Do not interfere with text edit
        if (keycode !== this.closeAllCode && this.isTextEditFocused()) {
            return;
        }
        this.keyCodes[keycode].action(e);
    }
    isTextEditFocused() {
        return false;
    }

    destroy() {
        window.removeEventListener('keyup', this._onkeyupInstance, true);
        window.removeEventListener('keydown', this._keydownInstance, true);
        window.removeEventListener('mousedown', this._onmouseInstance, true);
        window.removeEventListener('mousemove', this._onmouseInstance, true);

        this._onkeyupInstance = null;
        this._keydownInstance = null;
        this._onmouseInstance = null;
    }
}

